import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-98f8d370"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "authorizations py-12 px-8 mb-24" }
const _hoisted_2 = {
  key: 0,
  class: "h-100 w-100 d-flex flex-column align-items-center justify-content-center text-center"
}
const _hoisted_3 = { class: "h5 title text-primary mb-48" }
const _hoisted_4 = {
  key: 1,
  class: "scroll-component-container"
}
const _hoisted_5 = { class: "scroll-component" }
const _hoisted_6 = ["onClick", "aria-label"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center justify-content-center icon-section" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "icon icon-blank-alt-light",
    "aria-hidden": "true"
  })
], -1))
const _hoisted_8 = { class: "d-flex flex-column align-items-start" }
const _hoisted_9 = { class: "name text-tertiary fw-bold text-start mb-8" }
const _hoisted_10 = { class: "name fw-normal" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center justify-content-center ms-auto ps-8" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "icon icon-expand-right text-primary",
    "aria-hidden": "true"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_patient_purchase_authorization_show = _resolveComponent("the-patient-purchase-authorization-show")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.purchaseAuthorizations.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('No hay autorizaciones de compra')), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.purchaseAuthorizations, (authorization, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "item p-12",
                  key: index
                }, [
                  (_ctx.can('patient.expedient.show'))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        onClick: _withModifiers(($event: any) => (_ctx.showPurchaseAuthorizationShowModal(authorization)), ["prevent"]),
                        class: "btn btn-icon d-flex align-items-center item-content btn-sm p-0 justify-content-center",
                        "aria-label": _ctx.$t('Ver autorización de compra')
                      }, [
                        _hoisted_7,
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('{count} productos distintos', {count: authorization.products.length})), 1),
                          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('Emitida:')) + " " + _toDisplayString(_ctx.$str.formatDate(authorization.createdAt)), 1)
                        ]),
                        _hoisted_11
                      ], 8, _hoisted_6))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ]))
    ]),
    (_ctx.modalToShow === 'the-purchase-authorization-show')
      ? (_openBlock(), _createBlock(_component_the_patient_purchase_authorization_show, {
          key: 0,
          onClosed: _cache[0] || (_cache[0] = ($event: any) => {_ctx.modalToShow = null; _ctx.setCurrentPurchase()})
        }))
      : _createCommentVNode("", true)
  ], 64))
}